export enum NotificationsType {
  TYPE_WSMSG = 'TYPE_WSMSG', // 消息中心消息
  TYPE_COSYNC_CONFLICT = 'TYPE_COSYNC_CONFLICT', // 同步盘冲突消息
}

export interface NotificationsParam {
  type: NotificationsType;
  title: string;
  subtitle: string; // macOS可用
  body: string;
  extraData: string;
  hideWhenForeground: boolean; // 云盘在前台是否需要展示
}

export interface NotificationsCLickInfo {
  type: NotificationsType;
  extraData: string;
}

export enum SysNotificationsEevnet {
  EVENT_CLICK = 'EVENT_CLICK',
}
